import * as T from "fp-ts/lib/Task.js";

export const pure = T.of;
export const fromIO = T.fromIO;
export const run = (task) => task();
export const map = T.map;
export const chain = (task) => (next) => T.chain(next)(task);
export const sequence = (tasks) => () => Promise.all(tasks.map((task) => task()));
